<template>
    <Modal
      event-tracking-source="device limit popup"
      v-if="showModal"
      @close="close"
      class="text-center text-base"
    >
        <p class="my-2 mb-4" v-text="error"></p>
        <div class="flex justify-center my-2" slot="footer">
            <a class="bg-ma-red-1 hover:bg-ma-red-2 bg-ma-gray-22 hover:bg-ma-gray-3 capitalize font-semibold py-2 w-48 mx-auto sm:mx-0 text-white hover:text-white mt-4 sm:mt-0" @click.prevent="close">Close</a>
        </div>
    </Modal>
</template>

<script>
import Modal from '../../../components/Modal';

export default {
    components: {
        Modal
    },

    data: () => ({
        showModal: false
    }),

    computed: {
        error() {
            switch (this.$route.query.error) {
                case 'another-device':
                    return 'Your account has been logged in from another location. You are now logged out.';
                    break;
                case 'unknown':
                    return 'An unknown error occurred. Please try again.';
                    break;
                case 'multiple-devices':
                    return 'We have detected multiple logins on your account. All memberships are for single users only. Please contact support to unlock your account.';
                    break;
            }
        }
    },

	mounted: function() {
        // If ?error=[error-code], show modal
        if (this.error) {
            this.showModal = true;
        }
	},

	methods: {
        close() {
            this.showModal = false;
        }
    }
};
</script>

<style scoped>
::v-deep .modal-container {
    max-width: 400px;
    padding: 20px 30px;
}
</style>
